<template>
  <div>
    
    <div class="row mt-4">
      <div class="col-md-12">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por mesagem">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>
    </div>
    
    <hr>
  
    <div class="row mt-2">
      <div class="col-md-12">
        <router-link tag="button"
                     to="/unico_integration/settings/new"
                     class="btn btn-primary mt-1 mr-1"
        >
          Novo
        </router-link>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-12">
        
        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>
        
        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>Ativo</th>
              <th>Nome</th>
              <th>Criado por</th>
              <th>Atualizado por</th>
              <th>Tipos</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="setting in settings" :key="setting.id">
              <td>{{ setting.active }}</td>
              <td>{{ setting.name }}</td>
              <td>{{ setting.createdBy }}</td>
              <td>{{ setting.updatedBy }}</td>
              <td>{{ setting.types.join(', ') }}</td>
              <td>{{ setting.createdAt | datetime }}</td>
              <td>{{ setting.updatedAt | datetime }}</td>
              <td>
                <button @click="show(setting)" class="btn btn-outline">
                  Ver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        
        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
  import Pagination from '@/components/shares/specialTag/Pagination'
  import ModelMapper from '@/mixins/ModelMapper'
  import { SearchIcon } from 'vue-feather-icons'
  
  import 'vue-json-pretty/lib/styles.css'
  
  export default {
    components: { Pagination, SearchIcon },
    computed: {
      settings() {
        return this.getModels || []
      }
    },
    created() {
      this.$set(this.query, 'important', '')
      this.addOrderBy('createdAt')
    
      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })
    },
    data: () => ({
      modelPathPrefix: 'unico_integration',
      nameModel: 'Setting',
      showModal: false,
    }),
    methods: {
      find() {
        this.asyncTemplateSelect()
      },
      show(setting) {
        this.$ss.set(setting.id, setting, { minutes: 1 })
        this.$router.push(`/unico_integration/settings/${setting.id}`)
      }
    },
    mixins: [ModelMapper],
    name: 'Index',
  }
</script>

<style scoped>

</style>